import React, { useState, useEffect } from "react";
import { request } from "../../Utils/Request"
import Timer from "../../Utils/Timer"
import { isAuthenticated } from "../../Utils/Authenticated";
import {DateFormat, TimeLeft,TimetoDays} from "../../Utils/TimerProfile"
import Pagination from "../../components/Pagination/Pagination"
import { Link } from "react-router-dom"; 
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { callNumber } from "../../Utils/constant";
var a=1;
const BidsLost =   () => { 
        /* useEffect(()=>{
	if(!isAuthenticated()){
		props.history.push("/")
	}	
},[]) */

const [purchaseData, setPurchasedata] = useState({
  productDetail:[],
  totallist:0,
  pageperList:10,
  page:1
})

const handlePageChange = (evt, page)=>{
  setPurchasedata({
    ...purchaseData, page:page
  })
  a=parseInt(a)+10;
}
const asending=(e)=>{
  //  console.log("+++++++++",
  purchaseData.productDetail.sort((a,b)=>TimetoDays(a["bidTime"])-TimetoDays(b["bidTime"]))
   setPurchasedata({...purchaseData})
}
const desending=(e)=>{
  purchaseData.productDetail.sort((a,b)=>TimetoDays(a["bidTime"])-TimetoDays(b["bidTime"]))
  purchaseData.productDetail.reverse()
  setPurchasedata({...purchaseData})
}
const desending1=(e)=>{
  
  purchaseData.productDetail.sort((a,b)=>a["wprice"]-b["wprice"])
  purchaseData.productDetail.reverse()
  setPurchasedata({...purchaseData})
  
}
const asending1=(e)=>{
  //  console.log("+++++++++",
  purchaseData.productDetail.sort((a,b)=>a["wprice"]-b["wprice"])
  setPurchasedata({...purchaseData})
}







const getMypurchase = async()=>{
  const res = await request(
    "post",
    "/buyerDashboard",
    { status: "bidlost", page: purchaseData.page, sh_limit:purchaseData.pageperList}, false, true
  )
  console.log(res.data)
  if(res.data.success==="yes"){
    res.data.results.sort((a,b)=>TimetoDays(a["bidTime"])-TimetoDays(b["bidTime"]))
    setPurchasedata({
      ...purchaseData, productDetail :res.data.results, totallist:res.data.total_pagecnt
    })
  }
}
useEffect(()=>{
  getMypurchase()
},[purchaseData.page])

console.log(purchaseData.productDetail)

  return (
    <div className="ff-resp-table table-responsive">
    <table className="table w-100">
      <thead className="mobile-hide">
      
        <tr>
          
          <th>#</th>
          <th>Lot name</th>
          <th>Bid placed on<ArrowDropUpIcon onClick={asending}/><ArrowDropDownIcon onClick={desending}/></th>
          <th>My bid</th>
          <th>Winning Bid<ArrowDropUpIcon onClick={asending1}/><ArrowDropDownIcon onClick={desending1}/></th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
      
      {!purchaseData.productDetail.length ? 
      <tr>
        <td colspan="6" className="pd-zero text-center">
          <div className="card card-body">No bids lost</div>
        </td>
      </tr> 
      : 
      purchaseData.productDetail.map((item,key)=>
        <tr>
          <td className="resp-td" data-label="#">
            <div className="rtc-wrap">{parseInt(a)+parseInt(key)}</div>
          </td>
          <td className="resp-td" data-label="Lot name">
          <Link to={"/multi-items-view/"+item.id} style={{color:"var(--primColor)"}}> <div className="rtc-wrap"> {item.title}</div></Link>
          </td>
          <td className="resp-td" data-label="Bid placed on">
             <div className="rtc-wrap">{DateFormat(item.date_closed)}</div>
          </td>
          <td className="resp-td" data-label="My bid">
            <div className="rtc-wrap">€ {callNumber(item.lastproxtamt)}</div>
          </td> {/* To be confirmed later */}
          <td className="resp-td" data-label="Winning Bid">
             <div className="rtc-wrap">€ {callNumber(item.wprice)}</div>
          </td> 
          <td className="resp-td" data-label="Status">
            <div className="rtc-wrap">{item.market_status}</div>
          </td>
        </tr>  
        )} 
      </tbody>
    </table>
    <Pagination 
    count = {Math.ceil(purchaseData.totallist / purchaseData.pageperList)}
    onchange = {handlePageChange}
    />
    </div>
  );
};

export default BidsLost;
